import { formatUtcDateTime, utcStringToLocalDate } from '../utils/timezone'
import '../style/components/RecapWeekList.css'

type RecapWeekListProps = {
  items: Array<{
    id: string
    title?: string
    date_created?: string
    type?: 'CALL' | 'CHAT'
  }>
  onSelect?: (id: string, type?: 'CALL' | 'CHAT') => void
}

const badges = ['🗒️', '📅', '☎️', '🤝', '📌', '🧠', '🚀']

function RecapWeekList({ items, onSelect }: RecapWeekListProps) {
  const sorted = items.toSorted((a, b) => {
    const aTime = utcStringToLocalDate(a.date_created)?.getTime() ?? 0
    const bTime = utcStringToLocalDate(b.date_created)?.getTime() ?? 0
    return bTime - aTime
  })

  return (
    <div className="week-list">
      {sorted.map((item) => {
        const { date, time } = formatUtcDateTime(item.date_created)
        const title = (item.title || '').replace(/^["']+|["']+$/g, '').trim() || 'Untitled conversation'
        const badge = badges[sorted.indexOf(item) % badges.length]
        
        return (
          <div
            key={item.id}
            className={`week-card clickable ${item.type === 'CHAT' ? 'type-ai' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => onSelect?.(item.id, item.type)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onSelect?.(item.id, item.type)
              }
            }}
          >
            <div className="week-meta">
              <span className="tile-pill">{date}</span>
              <span className="tile-pill muted">{time || '—'}</span>
              {item.type === 'CHAT' && <span className="tile-pill chat-pill">Chat</span>}
            </div>
            <div className="week-emoji">{badge}</div>
            <div className="week-title" title={title}>
              {title}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default RecapWeekList
